import { useCallback, useState } from "react";
import { CartContent, NavBar, OrderSummary, SideNavBar } from "../widgets"
import { OrderSummaryProps } from "../widgets/orderSummary";
import styles from "./style.module.css"
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

const CartPage = () => {

  const showCart = useSelector((state: RootState) => state.CartState.isCartVisible);

  const [orderDetails, setOrderDetails] = useState<OrderSummaryProps>({
    numberOfItems: 0,
    subtotal: 0,
    deliveryFee: 0,
    tax: 0,
    storeDiscount: 0,
  });

  const handleCartUpdate = useCallback(({ total, itemCount }: { total: number; itemCount: number }) => {
    setOrderDetails(prev => ({
      ...prev,
      numberOfItems: itemCount,
      subtotal: total,
      deliveryFee: 30,
      tax: 30,
      storeDiscount: 100,
    }));
  }, []);
  
  console.log('Value of showCart from Redux:', showCart);
    if(!showCart) return null;

    return (
      <main className={styles.overlay}>
        
        <NavBar />

        <div className={styles.container}>

          <SideNavBar/>

          <CartContent onCartUpdate={handleCartUpdate}/>

          <OrderSummary {...orderDetails}/>

        </div>

      </main>
    );

}

export default CartPage